import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import { CountriesProvider } from "./context/countries.context";
import { CountryProvider } from "./context/country.context";
import { InputProvider } from "./context/input.context";
import { ModeProvider } from "./context/mode.context";
import "./styles/index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CountriesProvider>
        <ModeProvider>
          <CountryProvider>
            <InputProvider>
              <App />
            </InputProvider>
          </CountryProvider>
        </ModeProvider>
      </CountriesProvider>
    </BrowserRouter>
  </React.StrictMode>
);

